import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import {
  selectAccountId,
  selectSiteId,
} from '@epicuro-next/state/session-state';
import { Store } from '@ngrx/store';
import { combineLatest } from 'rxjs';
import { mergeMap, take } from 'rxjs/operators';

import { IRuleRequest } from '../rule-engine.interface';
import { RULE_ENGINE_API } from '../tokens';

export const ruleInterceptor: HttpInterceptorFn = (request, next) => {
  const store = inject(Store);
  const url = inject(RULE_ENGINE_API);

  if (!request.url.startsWith(`${url}/process`)) {
    return next(request);
  }

  return combineLatest([
    store.select(selectAccountId),
    store.select(selectSiteId),
  ]).pipe(
    take(1),
    mergeMap(([accountId, siteId]) => {
      if (!accountId || !siteId) {
        return next(request);
      }
      const newRequest = request.clone();
      const body = newRequest.body as IRuleRequest;
      body.ruleContextParams = {
        ...body.ruleContextParams,
        siteId,
        accountId,
      };
      return next(newRequest);
    }),
  );
};
